export default __webpack_public_path__ + "static/media/motivate.45c5226b.svg";